import * as _ from 'lodash';
import { Dispatch, connect } from "react-redux";
import { IApplicationState, AppActionCreators, CenterActionCreators, IAppState } from "@nkr/store/index";
import { Button, Table } from 'react-bootstrap';
import { ICenterAddress } from '@nkr/models/index';
import { useEffect, useState } from 'react';
import useCenterAddressList from '@nkr/store/center/hooks/use-center-address-list';
import styled from 'styled-components';
import CenterAddressAddEdit from './add-edit';
import ListRow from './list-row';
import ConfirmDelete from './confirm-delete';

const TableWrapper = styled(Table)`
    & > thead > tr > th {
        background-color: #133366;
        color: #fff;
        text-align: center;
    }

    & > tbody > tr > td {
        vertical-align: middle;
        text-align: center;
    }
`;

interface IProps {
    centerId: number,
    isCenter: boolean
}

interface IStateProps {
    app: IAppState,
    addAddress: boolean
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    setAddAddress: (addAddress: boolean) => void,
}

type TProps = IProps & IStateProps & IDispatchProps;

const AddressList = (props: TProps) => {
    const { list, fetchData, updateAddress, deleteAddress } = useCenterAddressList(props.centerId, props.app.site.organType);
    const [addEditAddress, setAddEditAddress] = useState<{ show: boolean, addressId: number }>({ show: false, addressId: 0 });
    const [confirmDeleteAddress, setConfirmDeleteAddress] = useState<{ show: boolean, data: ICenterAddress }>({ show: false, data: null });

    useEffect(() => {
    }, []);

    useEffect(() => {
        if (props.addAddress) {
            showAddEdit(0);
        }
    }, [props.addAddress])

    const showAddEdit = (addressId: number) => {
        setAddEditAddress({ show: true, addressId });
    }

    const handleAddAddress = () => {
        props.setAddAddress(true);
    }

    const confirmDelete = (id: number) => {
        let data = list.find(x => x.id == id);

        setConfirmDeleteAddress({
            show: true,
            data
        });
    }

    const handleAction = (id: number, e: any) => {
        if (e == 'EDIT') {
            showAddEdit(id);
        }

        if (e == 'DELETE') {
            confirmDelete(id);
        }
    }

    const handleAddEditUpdated = () => {
        setAddEditAddress({ show: false, addressId: 0 });
        fetchData(props.centerId, props.app.site.organType);
    }

    const handleCancelAddEdit = () => {
        setAddEditAddress({
            show: false,
            addressId: 0
        });
        
        props.setAddAddress(false);
    }

    const handleSubmitDelete = async () => {
        let id = confirmDeleteAddress.data.id;

        setConfirmDeleteAddress({
            show: false,
            data: null
        });

        await deleteAddress(id);

        fetchData(props.centerId, props.app.site.organType);
    }

    const handleCancelDelete = () => {
        setConfirmDeleteAddress({
            show: false,
            data: null
        });
    }
    
    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', marginBottom: 5 }}>
                <div style={{ display: 'flex', alignItems: 'right', marginLeft: 'auto' }}>
                    <Button bsStyle='primary' onClick={handleAddAddress}>Add Address</Button>
                </div>
            </div>

            <TableWrapper bordered condensed striped>
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Name</th>
                        <th>StrongBox Specific</th>
                        <th>Address</th>
                        <th>City</th>
                        <th>State</th>
                        <th>Postal Code</th>
                        <th>Note</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {list.map((address, index) =>
                        <ListRow
                            key={'ca-' + index}
                            address={address}
                            onAction={handleAction}
                        />
                    )}
                </tbody>
            </TableWrapper>

            <CenterAddressAddEdit
                show={addEditAddress.show}
                centerId={props.centerId}
                addressId={addEditAddress.addressId}
                allowedAddressTypes={[]}
                onUpdated={handleAddEditUpdated}
                onCancel={handleCancelAddEdit}
            />

            <ConfirmDelete
                show={confirmDeleteAddress.show}
                data={confirmDeleteAddress.data}
                onYes={handleSubmitDelete}
                onNo={handleCancelDelete}
            />
        </>
    );
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app,
        addAddress: state.centers.addAddress
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        setAddAddress: (addAddress) => {
            return dispatch(CenterActionCreators.setAddAddress(addAddress));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(AddressList)